// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + (chunkId === 647 ? "bulk add edit students page" : chunkId) + "." + {"95":"6e5bc7b6","357":"282d4744","570":"f427ba3a","647":"04731501","811":"954376ff"}[chunkId] + ".css";
};